import React from 'react'

import DetailLogo from '../../../content/model_detail/detail_logo'

import Images from '../../../components/Images/Images';

function HomeCertificates(_props){
    return (
        <div className="detail_certificates model_detail_section">            
            <div className="detail_certificates_bottom">
                <div className="detail_certiticates_logo">
                    <DetailLogo  _title="Certificados de calidad"></DetailLogo>
                </div>
                <div className="detail_certificates_logo_container">
                    
                    <div className="detail_certificates_logo_image_container">
                        <Images 
                            sources={{
                                mb: { url: '/assets/images/model_detail/certificados/mb/calorex_certificado_ance_mb.png' },
                                sm: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_ance_tb.png' },
                                md: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_ance_tb.png' },
                                lg: { url: '/assets/images/model_detail/certificados/dk/calorex_certificado_ance.png' },
                                url: '/assets/images/model_detail/certificados/dk/calorex_certificado_ance.png'
                            }}
                            alt="Calorex Certificado ANCE"
                        />
                    </div>    
                    <div className="detail_certificates_logo_image_container">
                        <Images 
                            sources={{
                                mb: { url: '/assets/images/model_detail/certificados/mb/calorex_certificado_conuee_mb.png' },
                                sm: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_cunee_tb.png' },
                                md: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_cunee_tb.png' },
                                lg: { url: '/assets/images/model_detail/certificados/dk/calorex_certificado_conuee.png' },
                                url: '/assets/images/model_detail/certificados/dk/calorex_certificado_conuee.png'
                            }}
                            alt="Calorex Certificado CONUEE"
                        />
                    </div>    
                    <div className="detail_certificates_logo_image_container">
                        <Images 
                            sources={{
                                mb: { url: '/assets/images/model_detail/certificados/mb/calorex_certificado_desing_certified_sa_mb.png' },
                                sm: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_desing_certified_sa_tb.png' },
                                md: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_desing_certified_sa_tb.png' },
                                lg: { url: '/assets/images/model_detail/certificados/dk/calorex_certificado_desing_certified_sa.png' },
                                url: '/assets/images/model_detail/certificados/dk/calorex_certificado_desing_certified_sa.png'
                            }}
                            alt="Calorex Certificado Design Certified SA"
                        />
                        
                    </div>     
                    <div className="detail_certificates_logo_image_container">
                        <Images 
                            sources={{
                                mb: { url: '/assets/images/model_detail/certificados/mb/calorex_certificado_hlw_mb.png' },
                                sm: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_hlw_tb.png' },
                                md: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_hlw_tb.png' },
                                lg: { url: '/assets/images/model_detail/certificados/dk/calorex_certificado_hlw.png' },
                                url: '/assets/images/model_detail/certificados/dk/calorex_certificado_hlw.png'
                            }}
                            alt="Calorex Certificado HLW"
                        />
                    </div>    
                    <div className="detail_certificates_logo_image_container">
                        <Images 
                            sources={{
                                mb: { url: '/assets/images/model_detail/certificados/mb/calorex_certificado_industria_limpia_mb.png' },
                                sm: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_industria_limpia_mb.png' },
                                md: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_industria_limpia_mb.png' },
                                lg: { url: '/assets/images/model_detail/certificados/dk/calorex_certificado_industria_limpia.png' },
                                url: '/assets/images/model_detail/certificados/dk/calorex_certificado_industria_limpia.png'
                            }}
                            alt="Calorex Certificado Industria Limpia"
                        />   
                    </div>    
                    <div className="detail_certificates_logo_image_container">
                        <Images 
                            sources={{
                                mb: { url: '/assets/images/model_detail/certificados/mb/calorex_certificado_iso_mb.png' },
                                sm: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_iso_tb.png' },
                                md: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_iso_tb.png' },
                                lg: { url: '/assets/images/model_detail/certificados/dk/calorex_certificado_iso.png' },
                                url: '/assets/images/model_detail/certificados/dk/calorex_certificado_iso.png'
                            }}
                            alt="Calorex Certificado ISO"
                        />            
                    </div>
                    <div className="detail_certificates_logo_image_container">
                        <Images 
                            sources={{
                                mb: { url: '/assets/images/model_detail/certificados/mb/calorex_certificado_nom_mb.png' },
                                sm: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_nom_tb.png' },
                                md: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_nom_tb.png' },
                                lg: { url: '/assets/images/model_detail/certificados/dk/calorex_certificado_nom.png' },
                                url: '/assets/images/model_detail/certificados/dk/calorex_certificado_nom.png'
                            }}
                            alt="Calorex Certificado NOM"
                        />
                    </div>
                    <div className="detail_certificates_logo_image_container">
                        <Images
                            sources={{
                                mb: { url: '/assets/images/model_detail/certificados/mb/calorex_certificado_sener_mb.png' },
                                sm: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_sener_tb.png' },
                                md: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_sener_tb.png' },
                                lg: { url: '/assets/images/model_detail/certificados/dk/calorex_certificado_sener.png' },
                                url: '/assets/images/model_detail/certificados/dk/calorex_certificado_sener.png'
                            }}  
                            alt="Calorex Certificado SENER"
                        />
                    </div>
                    <div className="detail_certificates_logo_image_container">
                        <Images
                            sources={{
                                mb: { url: '/assets/images/model_detail/certificados/mb/calorex_certificado_sige_mb.png' },
                                sm: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_sige_tb.png' },
                                md: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_sige_tb.png' },
                                lg: { url: '/assets/images/model_detail/certificados/dk/calorex_certificado_sige.png' },
                                url: '/assets/images/model_detail/certificados/dk/calorex_certificado_sige.png'
                            }}
                            alt="Calorex Certificado SIGE"
                        />
                    </div>
                    <div className="detail_certificates_logo_image_container">

                        <Images
                            sources={{
                                mb: { url: '/assets/images/model_detail/certificados/mb/calorex_certificado_ul_mb.png' },
                                sm: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_ul_tb.png' },
                                md: { url: '/assets/images/model_detail/certificados/tb/calorex_certificado_ul_tb.png' },
                                lg: { url: '/assets/images/model_detail/certificados/dk/calorex_certificado_ul.png' },
                                url: '/assets/images/model_detail/certificados/dk/calorex_certificado_ul.png'
                            }}
                            alt="Calorex Certificado UL"
                        />
                    </div>    
                </div>
            </div>
            
        </div>
    )
}
export default HomeCertificates
